module.exports = __webpack_public_path__ + "fonts/b417992bbd0c712b6a2bfacb1800944f-Roboto-ThinItalic.woff2";